import { createApiClient } from '../../utils/createApiClient';
import { useSession } from '../../Session/useSession';

export type ApiPrefix = 'backend' | 'identity';

export function useApiClient({
  prefix = 'backend',
  convert = true,
  baseURLOverride,
}: {
  prefix?: ApiPrefix;
  convert?: boolean;
  baseURLOverride?: string;
}) {
  const session = useSession();
  const baseURL = process.env.API_GATEWAY_URL + `/${prefix}`;

  return createApiClient({
    baseURL: baseURLOverride || baseURL,
    token: (session.token.data as string) || undefined,
    convert,
  });
}
